<template>
  <div id="roulette-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>American roulette</h1>
    <form class="game-wrapper layout-1" @submit="spin">
      <div class="layout-content">
        <div id="roulette-wrapper">
          <div id="roulette-static">
            <div id="roulette-wheel">
              <div id="roulette-ball-wrapper" v-if="ball_started">
                <div id="roulette-ball" :class="{'done': ball_done}">
                  <div id="roulette-ball-itself" :class="{'jump': ball_jump}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout-navigation"><button class="action-button" :disabled="in_progress">Spin the ball</button></div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

export default {
  data: function () {
    return {
      'destination': null,
      'ball_started': false,
      'ball_done': false,
      'in_progress': false,
      'ball_jump': false,
      't': null,
    }
  },
  beforeDestroy: function() {
    this.$data.t && clearTimeout(this.$data.t);
  },
  methods: {
    reset: function () {
      this.$data.destination = null;
      this.$data.ball_started = false;
      this.$data.ball_done = false;
      this.$data.ball_final = {};
    },
    spin: function (e) {
      e.preventDefault();
      if (this.$data.in_progress){
        return;
      } else {
        this.$data.in_progress = true;
      }
      this.reset();
      this.$data.t = setTimeout(() => {
        this.$data.ball_started = true;
        this.$data.t = setTimeout(() => {
          this.$data.ball_done = true;
          this.$data.ball_jump = true;
          this.$data.destination = Random.getNumber(0, 37);
          const delay = Math.round((this.$data.destination / 38 + 1) * 6000);
          document.getElementById('roulette-ball-wrapper').style.transition = `all ease-out ${delay}ms`;
          this.$data.t = setTimeout(() => {
            document.getElementById('roulette-ball-wrapper').style.transform = `rotate(${-360 / 38 * this.$data.destination - 360}deg)`;
            this.$data.t = setTimeout(() => {
              this.$data.ball_jump = false;
              this.$data.in_progress = false;
            }, delay);
          }, 8000);
        }, 8000);
      }, 20);
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  #roulette-game {
    background: #813215 url('../assets/img/game/roulette/bg.jpg') 50% 50%;
  }

  #roulette-static {
    width: 516px;
    height: 516px;
    background: url("../assets/img/game/roulette/static.png") 50% 50% no-repeat;
    background-size: contain;
    position: relative;
  }

  #roulette-wheel {
    width: 422px;
    height: 422px;
    margin: 0 0 -211px -211px;
    position: absolute;
    bottom: 50%;
    left: 50%;
    background: url("../assets/img/game/roulette/wheel.png") 50% 50% no-repeat;
    background-size: contain;
    animation: spin 16s linear infinite;
  }

  #roulette-ball-wrapper {
    width: 422px;
    height: 422px;
    margin: 0 0 -211px -211px;
    position: absolute;
    bottom: 50%;
    left: 50%;
  }

  #roulette-ball {
    width: 20px;
    position: absolute;
    bottom: 0;
    margin-left: -10px;
    left: 50%;
    animation: spin 4s linear 4 reverse;
    height: 482px;
    margin-bottom: -30px;
    transform: rotate(0deg);
  }

  #roulette-ball.done {
    height: 302px;
    margin-bottom: 60px;
    transition: all linear 8s;
  }

  #roulette-ball-itself {
    width: 20px;
    height: 20px;
    background: url("../assets/img/game/roulette/ball.png") 50% 0 no-repeat;
    background-size: contain;
  }

  #roulette-ball-itself.jump {
    animation: jump 0.25s linear infinite 5s;
  }

  #roulette-wrapper {
    width: 516px;
    height: 516px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -258px;
    margin-top: -258px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes jump {
    0% { margin-top: 0; }
    50% { margin-top: -5px; }
    100% { margin-top: 0; }
  }

</style>
